import React from "react";
import "./styles/App.scss";
import "@repo/ui/src/styles/globals.css";
import {
  extendTheme,
  ChakraProvider,
  withDefaultColorScheme,
} from "@chakra-ui/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { AuthContextProvider } from "./store/auth-context";
import customTheme from "./assets/customTheme";
import AppRoutes from "./routes";

const theme = extendTheme(
  customTheme,
  withDefaultColorScheme({
    colorScheme: "primary",
  })
);

const queryClient = new QueryClient();
function App() {
  return (
    <ChakraProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <AuthContextProvider>
          <AppRoutes />
          <ReactQueryDevtools initialIsOpen={false} />
        </AuthContextProvider>
      </QueryClientProvider>
    </ChakraProvider>
  );
}

export default App;
